(function($) {
    doc.on("click", `.part_ui_alert [data-click="close"]`, function(){
        let elm = $(this);
        elm.closest(".part_ui_alert").fadeOut(300);
        setTimeout(function() {
            elm.closest(".part_ui_alert").remove();
        },300);
    });
})(jQuery);